export enum SystemRoleEnum {
  Admin = 1,
  MerchantPreparer = 2,
  MerchantApprover = 3,
  SystemPreparer = 4,
  SystemApprover = 5,
  ReportsUser = 6,
  MerchantSupportStaff = 7,
  SystemSupportStaff = 8,
}
